
import { MachineComponentModel } from '@/libs/Api';
import Page from '@/Page.vue';
import { Component, Ref } from 'vue-property-decorator';
import { machineComponentsStore } from '@/libs/machine-components/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import MachineComponentDialog from './MachineComponentDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: { MachineComponentDialog },
})
export default class MachineComponentSelectDialog extends Page {
    dialog = false;
    search = '';
    selectedComponents: MachineComponentModel[] = [];
    
    @Ref() componentDialog!: any;

    headers = [
        { text: this.$i18n.t('machineComponents.code'), value: 'code', align: 'left', sortable: true },
        { text: this.$i18n.t('machineComponents.name'), value: 'name', align: 'left', sortable: true },
    ];

    get allComponents(): MachineComponentModel[] {
        const components = (machineComponentsStore.useGetter(CrudGetter.Data) as MachineComponentModel[]) ?? [];
        return components.sort((a, b) => (a.code ?? '').localeCompare(b.code ?? ''));
    }

    open(preselectedIds: string[] = []) {
        this.dialog = true;
        this.search = '';
        this.selectedComponents = this.allComponents.filter(c => preselectedIds.includes(c.id!));
    }

    close() {
        this.dialog = false;
        this.selectedComponents = [];
        this.search = '';
    }

    confirmSelection() {
        this.$emit('selected', this.selectedComponents);
        this.close();
    }

    createNew() {
        this.componentDialog.open(Guid.EmptyGuid());
    }

    onComponentCreated(component: MachineComponentModel) {
        // Automaticky přidat nově vytvořenou komponentu do výběru
        if (component && component.id && !this.selectedComponents.find(x => x.id === component.id)) {
            this.selectedComponents.push(component);
        }
    }
}
